import { useEffect } from 'react';
import { QueryClient, useQueryClient } from '@tanstack/react-query';

import { APIKey } from 'constants/apiKeys';
import { EXTRACT_ENTITIES_MUTATION_KEY } from 'shared/hooks/api/shiftNotes';
import { Note } from 'shiftNotes/_types';

export function seedEventNotes(
  queryClient: QueryClient,
  eventId: string,
  notes: Note[]
): void {
  const eventUpdatedAt =
    queryClient.getQueryState([APIKey.EVENT, eventId])?.dataUpdatedAt ?? 0;

  notes.forEach((note) => {
    const queryKey = [APIKey.SHIFT_NOTE, note.id];
    const noteUpdatedAt =
      queryClient.getQueryState(queryKey)?.dataUpdatedAt ?? 0;
    const isCachedNoteNewer = noteUpdatedAt > eventUpdatedAt;
    const isExtracting =
      queryClient.isMutating({
        mutationKey: EXTRACT_ENTITIES_MUTATION_KEY,
        predicate: (mutation) => mutation.state.variables === note.id,
      }) > 0;

    if (isCachedNoteNewer || isExtracting) return;

    queryClient.setQueryData<Note>(queryKey, note);
  });
}

export default function useSeedEventNotes(
  eventId: string,
  notes: Note[] | undefined
): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (notes) seedEventNotes(queryClient, eventId, notes);
  }, [eventId, notes, queryClient]);
}
